import { colors, IconLockSmall, spacing } from "@izettle/otto"
import { useLocalization } from "@izettle/tenko-react"

import { useModal } from "@/core/components/modal"
import { Flex, SmallText, SvgIcon, AnchorButton } from "@/core/components/shared"
import { Modals } from "@/modules/sign-up/components/types"
import {
  TrackingAction,
  useSignUpTracking,
  PrivacyPolicyFrom,
} from "@/modules/sign-up/hooks/tracking-sign-up"

type OptOutFooterProps = {
  orgName: string
  orgPrivacyPolicyLink?: string
}

export const OptOutFooter = ({ orgName, orgPrivacyPolicyLink }: OptOutFooterProps) => {
  const { text } = useLocalization()

  const [showPolicyModal] = useModal(Modals.Policy)
  const { track } = useSignUpTracking()

  const handlePolicyClicked = () => {
    showPolicyModal()
    track(TrackingAction.ViewedPrivacyPolicy, {
      page: PrivacyPolicyFrom.OptOutPage,
      sellerHasPrivacyPolicy: !!orgPrivacyPolicyLink,
    })
  }
  return (
    <Flex direction="column" style={{ marginTop: spacing.medium }}>
      <SmallText color={colors.text.secondary}>
        {text("SIGNUP_OPTOUT_FOOTER", [orgName])}
      </SmallText>
      <Flex>
        <SvgIcon
          html={IconLockSmall.svg}
          color={colors.action.primary.border.default}
          margin="0 16px 0 0"
        />
        <AnchorButton style={{ fontSize: "14px" }} onClick={handlePolicyClicked}>
          {text("SIGNUP_LEARN_HOW_YOUR_INFORMATION_IS_HANDLED")}
        </AnchorButton>
      </Flex>
    </Flex>
  )
}
